export const about = {
	about: {
		techStack: {
			title: "Tech Stack & Skills",
			description: "実務・個人開発で使用している技術スタックとスキルセット",
		},
		contact: {
			title: "連絡先",
			description: "お気軽にお問い合わせください。",
		},
		socials: {
			title: "SNS",
		},
	},
} as const;
